import SpotSurveyDetailDrawer from '@/views/expandstore/pages/spotsurveydetail/Drawer';
import { Spin } from 'antd';
import { FC, forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import SpotSurveyList from 'src/views/expandstore/pages/spotsurvey/components/List';
// import SpotSurveyFilter from 'src/views/expandstore/pages/spotsurvey/components/Filter';
import { useMethods } from '@lhb/hook';
import dayjs from 'dayjs';
import { spotSurveyExport } from '@/common/api/expandStore/spotSurvey';
import { usePageTitle } from '@/common/hook/usePageTitle';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { dispatchDownloadRemind } from '@/common/document-event/dispatch';

/**
 * @Description 拓店任务详情-踩点记录tab
 */
const SpotSurveyTab:FC<{detail, setShowSpotSurveyExport, ref, setHasData, isLocxx?: boolean}> = forwardRef(({ detail, setShowSpotSurveyExport, setHasData, isLocxx = false }, ref) => {
  const [filters, setFilter] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [detailDrawerData, setDetailDrawerData] = useState<any>({
    open: false,
    id: null
  });
  const { name: menuName } = usePageTitle();

  useImperativeHandle(ref, () => ({
    handleExport: methods.handleExport
  }));



  useEffect(() => {
    const modelClusterInfo = detail?.modelClusterInfo;
    setFilter({
      polygons: modelClusterInfo?.polygonStr,
      ...(isLocxx ? {
        longitude: modelClusterInfo?.centerLng,
        latitude: modelClusterInfo?.centerLat,
        distance: 500,
      } : {}),
    });
  }, [detail?.modelClusterInfo, isLocxx]);


  const methods = useMethods({
    onClickDetail(record: any) {
      setDetailDrawerData({
        open: true,
        id: record.id,
      });
    },
    onSearch(value:any) {
      setFilter({ ...filters, ...value });
    },
    handleExport() {
      const params: any = { ...filters };
      params.startDate =
                Array.isArray(params?.time) && params?.time.length > 0
                  ? dayjs(params.time[0]).format('YYYY-MM-DD')
                  : undefined;
      params.endDate =
                Array.isArray(params?.time) && params?.time.length > 1
                  ? dayjs(params.time[1]).format('YYYY-MM-DD')
                  : undefined;
      delete params.time;
      spotSurveyExport({ ...params, menuName })
        .then(() => {
          V2Message.success('本次下载的文件，请稍后前往"文件导出归档管理"查询');
          dispatchDownloadRemind();
        });
    }
  });

  return (
    <div className='mt-20'>
      <Spin spinning={loading}>
        {/* 测试没时间测线不上1113 */}
        {/* <SpotSurveyFilter onSearch={methods.onSearch} /> */}
        <SpotSurveyList
          mainHeight={400}
          filters={filters}
          onClickDetail={methods.onClickDetail}
          setLoading={setLoading}
          tableProps={{ type: 'easy' }}
          setHasExportPermission={setShowSpotSurveyExport}
          setHasData={setHasData}
        />
      </Spin>

      {/* 踩点详情抽屉 */}
      <SpotSurveyDetailDrawer
        drawerData={detailDrawerData}
        onClose={() => setDetailDrawerData({ open: false, id: null })}
      />
    </div>
  );
});

export default SpotSurveyTab;
